import React, { Component } from 'react';
import axios from "axios";
import {serverPath} from "./common";
import {Redirect} from 'react-router-dom';
class SignupVerificationComponent extends Component{
    constructor(props){
        super(props);
        this.state={
            message:"",
            redirect : false,
        };
    }
    componentDidMount() {
        const userId = this.props.match.params.uid;
        const token = this.props.match.params.token;
        const params = new URLSearchParams();
        params.append('action', 'verifyToken');
        params.append("userId", userId);
        params.append("token", token);
        axios.post(serverPath + "authService.php", params)
                .then((resp)=>{
                    if(resp.data !== null){
                        if(resp.data.success === true){
                            this.setState({
                                message:"Nalog uspešno verifikovan! Bićete preusmereni na početnu stranu.",
                            });

                        }
                        else{
                            switch (resp.data.message) {
                                case 'Allready verified!':
                                    this.setState({
                                        message:"Nalog je već verifikovan! Bićete preusmereni na početnu stranu"
                                    });
                                    break;
                                case 'Token expired!':
                                    this.setState({
                                        message:"Kod za verifikaciju je istekao! Ulogujte se ponovo i pratite uputstva! " +
                                            "Bićete preusmereni na početnu stranu."
                                    });
                                    break;
                                case 'Bad token!':
                                    this.setState({
                                        message:"Kod nije ispravan! Bićete preusmereni na početnu stranu."
                                    });
                                    break;
                                case 'Another user logged in!':
                                    this.setState({
                                        message:"Pokušavate da verifikujete nalog dok je drugi korisnik ulogovan." +
                                            "Izlogujte se i pokušajte ponovo! Bićete preusmereni na početnu stranu."
                                    });
                                    break;
                                default:
                                    this.setState({
                                        message:"Verifikacija nije uspela zbog nepoznate greske! Pokušajte ponovo. " +
                                            "Ukoliko se greška ponovi, obratite se administratoru. " +
                                            "Bićete preusmereni na početnu stranu."
                                    });
                                    break;
                            }
                        }
                        setTimeout(()=>{
                            this.setState({
                                redirect : true,
                            })
                        }, 3000);
                    }
                });

    }
    render(props) {
        if(this.state.redirect){
            return <Redirect to={"/"}/>
        }
        else{
            return <h1>{this.state.message}</h1>
        }
    }
}
export default SignupVerificationComponent;